// extracted by mini-css-extract-plugin
export var loadingSpinner = "_25-0";